module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-form-item",
    class: {
      'is-error': _vm.validateState === 'error',
        'is-required': _vm.isRequired || _vm.required,
        'is-showError': _vm.showMessage
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "ts-form-item--label",
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.prop
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ts-form-item--content",
    style: (_vm.contentStyle)
  }, [_vm._t("default"), _vm._v(" "), (_vm.validateState === 'error' && _vm.form.showMessage) ? _c('div', {
    staticClass: "ts-form-item--error"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.validateMessage) + "\n\t\t\t")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-202ab53a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/forms/tsFormItem.vue
// module id = 802
// module chunks = 39